import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const eur = (n) => (Number(n) || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });

export default function ExtraDashboard() {
  const now = new Date();
  const [anno, setAnno] = useState(now.getFullYear());
  const anni = [];
  for (let y = now.getFullYear() - 3; y <= now.getFullYear() + 1; y++) anni.push(y);

  const { data } = useQuery({
    queryKey: ["extra-dashboard", anno],
    queryFn: async () => (await api.get("/extra/dashboard", { params: { anno } })).data,
  });
  const mesi = data?.mesi || [];

  return (
    <div className="space-y-5" data-testid="extra-dashboard-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-head text-2xl font-bold">Dashboard Extra</h1>
          <p className="text-sm text-muted-foreground">Totali mensili e risultato progressivo da inizio anno</p>
        </div>
        <Select value={String(anno)} onValueChange={(v) => setAnno(Number(v))}>
          <SelectTrigger className="h-11 w-28 font-semibold" data-testid="extra-dash-anno-select"><SelectValue /></SelectTrigger>
          <SelectContent>{anni.map((y) => <SelectItem key={y} value={String(y)} data-testid={`extra-dash-anno-${y}`}>{y}</SelectItem>)}</SelectContent>
        </Select>
      </div>

      <div className="grid gap-3 sm:grid-cols-3">
        <div className="gr-card p-4 border-l-4" style={{ borderColor: "#1f7a5c" }} data-testid="extra-dash-tot-entrate">
          <div className="text-xs font-bold uppercase text-muted-foreground">Totale entrate {anno}</div>
          <div className="text-2xl font-head font-bold" style={{ color: "#1f7a5c" }}>{eur(data?.totale_entrate)}</div>
        </div>
        <div className="gr-card p-4 border-l-4" style={{ borderColor: "#c2410c" }} data-testid="extra-dash-tot-uscite">
          <div className="text-xs font-bold uppercase text-muted-foreground">Totale uscite {anno}</div>
          <div className="text-2xl font-head font-bold" style={{ color: "#c2410c" }}>{eur(data?.totale_uscite)}</div>
        </div>
        <div className="gr-card p-4 border-l-4" style={{ borderColor: "#2f6fb0" }} data-testid="extra-dash-risultato-anno">
          <div className="text-xs font-bold uppercase text-muted-foreground">Risultato anno</div>
          <div className="text-2xl font-head font-bold" style={{ color: (data?.risultato_anno || 0) >= 0 ? "#1f7a5c" : "#dc2626" }}>{eur(data?.risultato_anno)}</div>
        </div>
      </div>

      <div className="gr-card p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b bg-muted/40 text-left">
              <th className="px-4 py-3 font-bold">Mese</th>
              <th className="px-4 py-3 font-bold text-right">Entrate</th>
              <th className="px-4 py-3 font-bold text-right">Uscite</th>
              <th className="px-4 py-3 font-bold text-right">Risultato mese</th>
              <th className="px-4 py-3 font-bold text-right">Progressivo (da inizio anno)</th>
            </tr>
          </thead>
          <tbody>
            {mesi.map((m) => (
              <tr key={m.mese} className="border-b hover:bg-muted/20" data-testid={`extra-dash-row-${m.mese}`}>
                <td className="px-4 py-2.5 font-semibold">{MESI[m.mese - 1]}</td>
                <td className="px-4 py-2.5 text-right tabnum" style={{ color: m.entrate ? "#1f7a5c" : "inherit" }}>{eur(m.entrate)}</td>
                <td className="px-4 py-2.5 text-right tabnum" style={{ color: m.uscite ? "#c2410c" : "inherit" }}>{eur(m.uscite)}</td>
                <td className="px-4 py-2.5 text-right font-semibold tabnum" style={{ color: m.risultato >= 0 ? "#1f7a5c" : "#dc2626" }}>{eur(m.risultato)}</td>
                <td className="px-4 py-2.5 text-right font-bold tabnum" style={{ color: m.progressivo >= 0 ? "#1f7a5c" : "#dc2626" }} data-testid={`extra-dash-prog-${m.mese}`}>{eur(m.progressivo)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
